<template><ReportDetail read-only /></template>
<script>
import ReportDetail from '@/components/RecordDetails/ReportDetail.vue';
export default { components: { ReportDetail } };
</script>
